(function () {

    angular
        .module('smartertoolsApp')
        .controller('highAvailabilityLicensesController',
            [
                '$scope', '$q', '$timeout', 'highAvailabilityPartnerService', 'partnerService', 'notificationFactory', 'authenticationService', 'refreshToken', 'cacheControl', '$http', highAvailabilityLicensesController
            ]);

    function highAvailabilityLicensesController($scope, $q, $timeout, highAvailabilityPartnerService, partnerService, notify, authenticationService, refreshToken, cacheControl, $http) {
        const vm = this;
        vm.mode = 'main';
        vm.licenses = null;
        vm.licenseSearch = '';
        vm.currentPage = 1;
        vm.itemsPerPage = 10;
        vm.partnerInfo = null;
        vm.selectedLease = null;
        vm.totalFilteredItems = 0;
        vm.isProcessing = false;
        vm.newLease = {};
        vm.upgradeLease = {};
        vm.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        vm.agreement = {subject: '', body: '', type: '', isAccepted: false};
        vm.startModal = {
            state: 'loading',
            productOptions: [],
            selectedProduct: null,
            selectedAddons: [],
            clusterName: '',
            isSending: false,
            onPage1Next: onPage1Next,
            onPage2Next: onPage2Next,
            recalculatePage1Items: recalculatePage1Items,
        }
        vm.modifyModal = {
            state: 'loading',
            licenseId: null,
            productOptions: [],
            selectedProduct: null,
            selectedAddons: [],
            clusterName: '',
            isSending: false,
            onPage1Next: onModifyPage1Next,
            onPage1Back: onModifyPage1Back,
            onPage2Next: onModifyPage2Next,
            recalculatePage1Items: recalculateModifyPage1Items,
        }
        vm.paging = {page: 1, itemsPerPage: 25};

        // Functions
        vm.doLicenseStop = doLicenseStop;
        vm.filter = filter;
        vm.getCsvData = getCsvData;
        vm.getCsvHeader = getCsvHeader;
        vm.recalcStartLeaseItems = recalcStartLeaseItems;
        vm.refreshData = refreshData;
        vm.selectLease = selectLease;
        vm.showBillingDetails = showBillingDetails;
        vm.showHighAvailabilityStart = showHighAvailabilityStart;
        vm.showLicenseStop = showLicenseStop;
        vm.showLicenseUpgrade = showLicenseUpgrade;
        vm.showTermsAgreementOverlay = showTermsAgreementOverlay;
        vm.sort = sort;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refreshData();
        }

        function refreshData() {
            $scope.accountCtrl.isLoading += 2;
            $q.all(
                [
                    refreshLicenses(),
                    partnerService.getPartnershipDetails(),
                ])
                .then((values) => {
                    $scope.accountCtrl.isLoading -= 2;
                    vm.partnerInfo = values[1];
                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch((e) => {
                    if (e.status == 403) {
                        window.location.href = '/company/partners';
                        return;
                    }
                    $scope.accountCtrl.isLoading -= 2;
                    notify.error('There was a problem loading this information.  Please try again later.');
                });
        }

        function filter() {
            $timeout(() => {
                vm.totalFilteredItems = vm.filteredLicenseKeys ? vm.filteredLicenseKeys.length : 0;
            }, 10);
        }

        function refreshLicenses() {
            return highAvailabilityPartnerService.getActiveLicenses()
                .then((licenses) => {
                    vm.licenses = licenses;
                    vm.filter();
                });
        }

        function sort(keyName) {
            vm.reverse = vm.sortKey !== keyName || !vm.reverse;
            vm.sortKey = keyName;
        }

        function getCsvHeader() {
            return ['Lease ID', 'Start Date', 'Email Address', 'Product', 'Addons', 'Machine Name', 'Last Activated IP', 'Monthly Cost to You', 'Customer Name', 'Custom ID', 'Custom Data'];
        }

        function getCsvData() {
            let items = [];
            for (let i = 0; i < vm.licenses.length; i++) {
                const item = vm.licenses[i];
                let addonNames = '';
                for (let j = 0; j < item.Addons.length; j++) {
                    const a = item.Addons[j];
                    if (addonNames != '')
                        addonNames += ', ';
                    addonNames += a.MasterProductName == 'Exchange ActiveSync' ? a.Product : a.MasterProductName;
                }
                items.push({
                    leaseid: item.LeaseId,
                    start: moment(item.StartDate).format(),
                    email: item.Email,
                    product: item.Product,
                    addons: addonNames,
                    machineName: item.MachineName,
                    lastActivatedIpAddress: item.LastActivatedIpAddress,
                    monthlyCost: '$' + item.TotalCost,
                    customerName: item.CustomerName,
                    customId: item.CustomId,
                    customData: item.CustomData,

                });
            }
            return items;
        }

        function selectLease(item) {
            vm.selectedLeaseMode = 'start';
            vm.selectedLease = item;
            vm.selectedLeaseHistory = null;
            vm.isProcessing = false;
            vm.resendDone = false;
            bootstrap.Tab.getOrCreateInstance(document.getElementById('lease-details-tab')).show();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-license-view-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function showLicenseStop() {
            vm.selectedLeaseMode = 'stop-confirmation';
        }

        function showLicenseUpgrade() {
            vm.availableProductInfo = null;

            highAvailabilityPartnerService.getProductsAvailable()
                .then((products) => {
                    // From startLease
                    vm.modifyModal.productOptions = products;
                    for (let productOptionIndex in vm.modifyModal.productOptions) {
                        let product = vm.modifyModal.productOptions[productOptionIndex];
                        if (product.ProductId === vm.selectedLease.ProductId) {
                            vm.modifyModal.selectedProduct = product;
                            break;
                        }
                    }

                    let newAddonIds = [];
                    let newAddonIdsIndexed = [];
                    let existingAddonSelections = vm.selectedLease.Addons;

                    for (let addonSelection in existingAddonSelections) {
                        let addon = existingAddonSelections[addonSelection];
                        newAddonIds.push(addon.ProductId);
                    }

                    for (let addonCategoryIndex in vm.modifyModal.selectedProduct.AddonsByCategory) {
                        const addonCategory = vm.modifyModal.selectedProduct.AddonsByCategory[addonCategoryIndex];

                        for (let addonOptionIndex in addonCategory.Addons) {
                            const addonOption = addonCategory.Addons[addonOptionIndex];

                            if (newAddonIds.indexOf(addonOption.ProductId) !== -1) {
                                newAddonIdsIndexed[addonCategoryIndex] = addonOption.ProductId;
                            }
                        }
                    }

                    vm.modifyModal.clusterName = vm.selectedLease.CustomData;
                    vm.modifyModal.selectedAddons = newAddonIdsIndexed;
                    vm.modifyModal.haModifyModalForm.$setPristine();
                    vm.modifyModal.haModifyModalForm.$setUntouched();
                    vm.modifyModal.state = 'page1';
                    recalculateFreeAddons(vm.modifyModal);
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-license-view-modal')).hide();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-modify-modal')).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch((err) => {
                    console.error(err);
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-license-view-modal')).hide();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-modify-modal')).hide();
                });
        }


        function doLicenseStop() {
            vm.isProcessing = true;
            highAvailabilityPartnerService.stopLicense(vm.selectedLease.LicenseId)
                .then(async (result) => {
                    highAvailabilityPartnerService.clearCache();
                    await refreshLicenses();
                    vm.isProcessing = false;
                    vm.selectedLeaseMode = 'stop-result';
                })
                .catch((err) => {
                    vm.isProcessing = false;
                    //TODO: notify
                });
        }

        function recalcStartLeaseItems() {
            //recalcLeaseItems(vm.newLease);
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function showBillingDetails(license) {
            vm.billingDetailsLicense = license;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-license-view-modal')).hide();
        }

        function showTermsAgreementOverlay() {
            authenticationService.getAgreement((data) => {
                vm.agreement.body = data.Body;
                vm.agreement.subject = data.Subject;
                vm.agreement.type = data.Type;
                const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-partner-agreement-resource'));
                modal.show();
            });
        }

        function showHighAvailabilityStart() {
            /*authenticationService.showTermsCondition((data) => {
                if (data) {
                    ShowTermsAgreementOverlay();
                } else {*/
                    highAvailabilityPartnerService.getProductsAvailable()
                        .then((products) => {
                            vm.startModal.productOptions = products;
                            if (products.length === 1)
                                vm.startModal.selectedProduct = products[0];
                            vm.startModal.haStartModalForm.$setPristine();
                            vm.startModal.haStartModalForm.$setUntouched();
                            vm.startModal.state = 'page1';
                            recalculateFreeAddons(vm.startModal);
                            bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-start-modal')).show();
                            $timeout(() => RecalculateAllFloatLabelControls());
                        });
                /*}
            });*/
        }

        function onPage1Next() {
            if (vm.startModal.haStartModalForm.$invalid)
                return;

            try {
                let priceNotes = [];
                vm.startModal.isSending = true;

                // Run through all options, and calculate pricing notes
                const addonsByCategory = vm.startModal.selectedProduct.AddonsByCategory;
                for (let addonIndex in addonsByCategory) {
                    let addonByCategory = addonsByCategory[addonIndex].Addons;
                    for (let productIndex in addonByCategory) {
                        let product = addonByCategory[productIndex];
                        if (vm.startModal.selectedAddons[addonIndex] == product.ProductId) {
                            priceNotes.push(product)
                        }
                    }
                }

                vm.startModal.selectedProduct.PriceNotes = priceNotes;
                vm.startModal.state = 'page2';
            } finally {
                vm.startModal.isSending = false;
            }

        }

        function onPage2Next() {
            if (vm.startModal.haStartModalForm.$invalid)
                return;

            let addonIds = [];
            for (let addonCategoryKey in vm.startModal.selectedAddons) {
                if (!vm.startModal.selectedAddons.hasOwnProperty(addonCategoryKey)) continue;

                const addonId = vm.startModal.selectedAddons[addonCategoryKey];
                if (!addonId)
                    continue;
                addonIds.push(addonId);
            }

            highAvailabilityPartnerService.startLicense(vm.startModal.clusterName, vm.startModal.selectedProduct.ProductId, addonIds)
                .then(async (result) => {
                    highAvailabilityPartnerService.clearCache();
                    await refreshLicenses();
                    vm.startModal.result = result;
                    vm.startModal.isSending = false;
                    vm.startModal.done = true;
                    vm.startModal.state = 'page3';
                })
                .catch((err) => {
                    vm.startModal.isSending = false;
                });
        }

        function recalculateFreeAddons(model){
            if (model.selectedProduct && model.selectedProduct.AddonsByCategory) {
                for (let i = 0; i < model.selectedProduct.AddonsByCategory.length; i++) {
                    let addonCategory = model.selectedProduct.AddonsByCategory[i];
                    let isIncludedForFree =
                        addonCategory.Addons.length === 1 &&
                        addonCategory.Addons[0].MonthlyCost == 0 &&
                        addonCategory.Addons[0].MonthlyCostPerHub == 0 &&
                        addonCategory.Addons[0].MonthlyCostPerNode == 0;
                    addonCategory.IsIncludedForFree = isIncludedForFree;
                    if (isIncludedForFree)
                        model.selectedAddons[i] =  addonCategory.Addons[0].ProductId;
                }
            }
        }
        
        function recalculatePage1Items() {
            $timeout(() => {
                 RecalculateAllFloatLabelControls();
            });
        }

        function onModifyPage1Back() {
            bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-modify-modal')).hide();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('ha-license-view-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function onModifyPage1Next() {
            if (vm.modifyModal.haModifyModalForm.$invalid)
                return;

            try {
                let priceNotes = [];
                vm.modifyModal.isSending = true;

                // Run through all options, and calculate pricing notes
                const addonsByCategory = vm.modifyModal.selectedProduct.AddonsByCategory;
                for (let addonIndex in addonsByCategory) {
                    let addonByCategory = addonsByCategory[addonIndex].Addons;
                    for (let productIndex in addonByCategory) {
                        let product = addonByCategory[productIndex];
                        if (vm.modifyModal.selectedAddons[addonIndex] == product.ProductId) {
                            priceNotes.push(product)
                        }
                    }
                }

                vm.modifyModal.selectedProduct.PriceNotes = priceNotes;
                vm.modifyModal.state = 'page2';
            } finally {
                vm.modifyModal.isSending = false;
            }

        }

        function onModifyPage2Next() {
            if (vm.modifyModal.haModifyModalForm.$invalid)
                return;

            let addonIds = [];
            for (let addonCategoryKey in vm.modifyModal.selectedAddons) {
                if (!vm.modifyModal.selectedAddons.hasOwnProperty(addonCategoryKey)) continue;

                const addonId = vm.modifyModal.selectedAddons[addonCategoryKey];
                if (!addonId)
                    continue;
                addonIds.push(addonId);
            }

            highAvailabilityPartnerService.modifyLicense(vm.selectedLease.LicenseId, vm.modifyModal.clusterName, vm.modifyModal.selectedProduct.ProductId, addonIds)
                .then(async (result) => {
                    highAvailabilityPartnerService.clearCache();
                    await refreshLicenses();
                    vm.modifyModal.result = result;
                    vm.modifyModal.isSending = false;
                    vm.modifyModal.done = true;
                    vm.modifyModal.state = 'page3';
                })
                .catch((err) => {
                    vm.modifyModal.isSending = false;
                });
        }

        function recalculateModifyPage1Items() {
            $timeout(() => RecalculateAllFloatLabelControls());
        }

    }

})();